/**
 * Created by slava on 27/10/17
 */

// needed for closure optimization of bundle plugins namespace
// eslint-disable-next-line no-var
var bundles = {};

const unminifyRec = function (object, id, bundleName) {
    const el = object[id];
    if (typeof el === "object") {
        for (const i in el) {
            if (i === "meta" && id === bundleName) {
                continue;
            }
            if (id === "jsons" && el[i] && el[i].inline) {
                continue;
            }
            unminifyRec(el, i, bundleName);
        }
    } else if (typeof el === "string" && el.includes("#")) {
        object[id] = el.replace(/#/g, bundleName);
    }
};

const BundleManifests = {
    add: function (manifests) {
        for (const name in manifests) {
            this.addBundle(name, manifests[name]);
        }
    },

    injectPlugins: function () {
        for (const name in bundles) {
            const bundle = bundles[name];

            if (!bundle.virtual || !bundle.injectTo || !bundle.plugins[name]) {
                continue;
            }

            bundle.injectTo.forEach((target) => {
                if (bundles[target]) {
                    bundles[target].plugins[name] = bundle.plugins[name];
                }
            });
        }
    },

    addBundle: function (name, manifest) {
        if (!manifest.frames) {
            manifest.frames = {};
        }
        if (!manifest.jsons) {
            manifest.jsons = {};
        }
        if (!manifest.urls) {
            manifest.urls = {};
        }
        if (!manifest.meta) {
            manifest.meta = {};
        }

        unminifyRec({ [name]: manifest }, name, name);

        if (manifest.injectTo && manifest.frameIds) {
            manifest.frameIds.forEach((frameId) => {
                manifest.frames[frameId] = "";
            });
            delete manifest.frameIds;
        }
        if (manifest.jsonIds) {
            manifest.jsonIds.forEach((jsonId) => {
                manifest.jsons[jsonId] = "";
            });
            delete manifest.jsonIds;
        }
        if (manifest.injectTo && manifest.soundIds) {
            manifest.soundIds.forEach((soundId) => {
                manifest.urls[soundId] = "";
            });
            delete manifest.soundIds;
        }
        if (manifest.injectTo && manifest.unpackedIds) {
            manifest.unpackedIds.forEach((unpackedId) => {
                manifest.urls[unpackedId] = "";
            });
            delete manifest.unpackedIds;
        }

        if (manifest.important) {
            manifest.important = cleverapps.createSet(manifest.important);
        }

        if (manifest.meta.lazy) {
            manifest.meta.lazy = cleverapps.createSet(manifest.meta.lazy);
        }

        bundles[name] = new Bundle(name, manifest);
    }
};
